import { ApiResult } from '../../apiClient/apiResult';
import { axiosClient } from '../../apiClient/axiosClient';
import { MediaTag } from '../../types/mediaTag';

type ArticleTagIndexResponse = MediaTag[];

export const articleTagApiClient = {
  index: async (): Promise<ApiResult<ArticleTagIndexResponse>> => {
    return await axiosClient.get('/company/media-tags');
  },
};
